/**
 * Browser-side pdf.js setup, centralized so the worker is configured once and
 * components import `getDocument` from here (and tests can mock this module).
 *
 * This is the BROWSER render path — distinct from the Node test harness in
 * tests/cross-engine.test.ts (which rasterizes with pdftoppm because pdf.js +
 * node-canvas render blank in Node). In a real browser, pdf.js renders to a
 * native <canvas> and works correctly.
 */

import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

GlobalWorkerOptions.workerSrc = workerUrl;

export { getDocument };
export type { PDFDocumentProxy, PDFPageProxy } from "pdfjs-dist";
